import Annuncio from "./Annuncio";

export default Annuncio;
